import React, { useState, useEffect } from 'react';
import Chip from '@mui/material/Chip';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

export default function MultiAutoComplete({ field = {}, values = {}, onChange = () => {}, ...props }) {
  const initialValue = props.fieldValues ? props.fieldValues[field.key] : values[field.key];

  // Fallback to empty array if undefined
  const [selectedOptions, setSelectedOptions] = useState(initialValue || []);

  // Ensure local state updates if parent form passes new values (e.g. from saved preferences API)
  useEffect(() => {
    const incomingValue = props.fieldValues ? props.fieldValues[field.key] : values[field.key];
    if (incomingValue !== undefined) {
      setSelectedOptions(incomingValue);
    }
  }, [props.fieldValues, values, field.key]);

  useEffect(() => {
    if (!field.show) {
      onChange(field, null);
    }
  }, [field.show]);

  const handleOnChange = (event, newValue) => {
    // Check if the parent passed a 'selectAllValue' flag AND if the user just selected it
    if (field.selectAllValue && newValue.some(x => x.value === field.selectAllValue)) {
      
      // Get all option values EXCEPT the "Select All" placeholder itself
      const allRealValues = field.options
        .filter(option => option.value !== field.selectAllValue)
        .map(option => option.value);

      setSelectedOptions(allRealValues);
      onChange(field, allRealValues);
    } else {
      const mappedValues = newValue.map(x => x.value);
      setSelectedOptions(mappedValues);
      onChange(field, mappedValues);
    }
  };

  return (
    <Autocomplete
      multiple
      id="checkboxes-autocomplete"
      className='mb-3'
      disableCloseOnSelect
      options={field.options.filter(option => !selectedOptions.includes(option.value))}
      onChange={handleOnChange}
      value={field.options.filter(option => selectedOptions.includes(option.value))}
      getOptionLabel={(option) => option.label || "Unknown"}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      disabled={field.disabled}
      style={{ display: field.show ? 'block' : 'none' }}
      limitTags={2}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => {
              const { key, ...tp } = getTagProps({ index });
              return (
                <Chip key={key} variant="outlined" label={option.label} size="small" style={{ margin: '2px' }} {...tp} />
              );
            })
      }
      renderInput={(params) => (
        <TextField {...params} variant="outlined" label={field.label} placeholder={field.label} style={{ width: "100%" }} />
      )}
    />
  );
}